module.exports = __webpack_public_path__ + "img/sergeant-tips-icon2.f518c2bf.png";